import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { addressService } from '../../services/address.service';
import type { Address } from '../../types';
import { useAuthStore } from '../../stores/useAuthStore';

export const useAddresses = () => {
    const { isAuthenticated, client } = useAuthStore();
    return useQuery({
        queryKey: ['addresses'],
        queryFn: addressService.getAddresses,
        enabled: isAuthenticated && !!client,
    });
};

export const useCreateAddress = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (address: Omit<Address, 'uuid' | 'created_at'>) => addressService.createAddress(address),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['addresses'] });
        },
    });
};

export const useUpdateAddress = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, address }: { id: string; address: Partial<Address> }) =>
            addressService.updateAddress(id, address),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['addresses'] });
        },
    });
};

export const useDeleteAddress = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: string) => addressService.deleteAddress(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['addresses'] });
        },
    });
};
